export default "__VITE_ASSET__CKdy6E5W__"